import { render, staticRenderFns } from "./RptAllAgentRwdDet.vue?vue&type=template&id=424d547a"
import script from "./RptAllAgentRwdDet.vue?vue&type=script&lang=js"
export * from "./RptAllAgentRwdDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports